import axios from 'axios';
import {apiService} from "./api.service";
import {convertToPageable, handleApiException, handleResponse} from "../helpers/apiResponseHelper";

async function getAllTanks(customerId: number, pageRequest: any) {
    return axios.get(apiService.getApiUrl() + '/tanks/' + customerId, {
        params: pageRequest
    }).then(handleResponse).then(convertToPageable).catch(handleApiException);
}

const TanksService = {
    getAllTanks
};

export default TanksService;
